import src from "IMAGE";
export default { src, width: 120, height: 120, blurWidth: 0, blurHeight: 0};
